import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "app-dropdown-chevron",
  templateUrl: "./dropdown-chevron.component.html",
  styleUrls: ["./dropdown-chevron.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    "[class.open]": "open()",
  },
})
export class DropdownChevronComponent {
  public readonly open = input<boolean>(false);
}
